export const locale = {
    lang: 'pl',
    data: {
        'Device details': 'Dane urządzenia',
        'Free': 'Wolne',
        'Number': 'Numer',
        'Loading data': 'Wczytuję dane',
        'Device is online': 'Urządzenie jest aktywne',
        'Device is offline': 'Urządzenie jest nieaktywne',
        'Training in progress': 'W trakcie treningu',
        'Card number': 'Numer karty',
        'Cancel': 'Anuluj',
        'Confirm': 'Potwierdź',
        'User exercising on the device': 'Użytkownik ćwiczący na urządzeniu',
        'Device': 'Urządzenie',
        'Name': 'Imię i nazwisko',
        'Email': 'Email',
        'Phone': 'Telefon',
        'Birthday': 'Data urodzenia',
        'years': 'lat',
        'Close': 'Zamknij',
        'Go to customer details': 'Przejdź do danych klienta',
        'User Info': 'Informacje o użytkowniku',
        'Statistics': 'Statystyki',
        'Device Training Statistics': 'Statystyki treningów urządzenia',
        'Serial Number': 'Numer seryjny',
        'Period': 'Okres',
        'Last 7 days': 'Ostatnie 7 dni',
        'Last 14 days': 'Ostatnie 14 dni',
        'Last 30 days': 'Ostatnie 30 dni',
        'Last 60 days': 'Ostatnie 60 dni',
        'Last 90 days': 'Ostatnie 90 dni',
        'Total Trainings': 'Suma treningów',
        'Avg per Day': 'Średnio dziennie',
        'Loading statistics...': 'Ładowanie statystyk...',
        'Retry': 'Spróbuj ponownie',
        'Number of trainings': 'Liczba treningów',
        'No training data available for the selected period': 'Brak danych treningowych dla wybranego okresu'
    }
};
